<img src="assets/grupo-madero-logo.svg" alt="Logo Grupo Madero" width="300" height="150" />
<div class="portal-language-selector">
  <madero-language-selector></madero-language-selector>
</div>
<!-- if any error occours that invalid the portal flow (joining queue, get branch data, etc) -->
@if (flowError()) {
  <div class="fade-in-left text-center flow-error">
    <h2>Portal do Cliente</h2>
    <p>Não foi possível carregar os dados necessários. Por favor, tente novamente em alguns segundos.</p>
  </div>
} @else {
  @if (isLoadingBranch() || isLoadingEntry()) {
    <div class="fade-in-left branch-loading">
      <mat-spinner color="primary" diameter="50"></mat-spinner>
      <p>Aguarde o carregamento da {{ isLoadingBranch() ? 'filial' : 'fila' }}...</p>
    </div>
  } @else {
    @if (branch()) {
      @if (entry()) {
        <madero-queue class="fade-in-left" (leaveQueue)="onExitWaitingList()"></madero-queue>
      } @else if (showWaitingList()) {
        <madero-waiting-list
          class="fade-in-left"
          (return)="showWaitingList.set(false)"
          (joinedWaitingList)="onJoinedWaitingList($event)">
        </madero-waiting-list>
      } @else {
        <madero-welcome (joinWaitingList)="showWaitingList.set(true)"></madero-welcome>
      }
    }
  }
}
